import { useEffect, useState } from "react";
import { getLeadAssignees, updateLead } from "@/lib/apiClient";
import { UserCheck } from "lucide-react";
import { toast } from "sonner";

let usersCache = null;
const stop = (e) => e.stopPropagation();

// Who should call this lead (admin assigns/switches) + who already contacted it, to avoid double calls.
export function LeadAssign({ lead, isAdmin, onChanged }) {
  const [users, setUsers] = useState(usersCache || []);
  useEffect(() => {
    if (!isAdmin || usersCache) return;
    getLeadAssignees().then((u) => { usersCache = u; setUsers(u); }).catch(() => {});
  }, [isAdmin]);
  const assign = async (id) => {
    try { onChanged(await updateLead(lead.id, { assigned_user_id: id })); toast.success(id ? "Lead toegewezen" : "Toewijzing verwijderd"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Mislukt"); }
  };
  const contacted = lead.last_contact_name
    ? `Gecontacteerd door ${lead.last_contact_name} · ${new Date(lead.last_contact_at).toLocaleDateString("nl-NL", { day: "numeric", month: "short" })}`
    : "Nog niet gecontacteerd";
  return (
    <div className="text-xs space-y-1 w-48" onClick={stop}>
      {isAdmin ? (
        <select data-testid={`assign-${lead.id}`} value={lead.assigned_user_id || ""} onChange={(e) => assign(e.target.value)}
          className={`fe-input py-1 text-xs ${lead.assigned_user_id ? "text-[#001C51] font-medium" : "text-[#8994A3]"}`}>
          <option value="">Niet toegewezen</option>
          {users.map((u) => <option key={u.id} value={u.id}>Bellen: {u.name}</option>)}
        </select>
      ) : (
        <p data-testid={`assignee-${lead.id}`} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full ${lead.assigned_user_name ? "bg-[#E3E9F5] text-[#001C51]" : "bg-[#EDF1F5] text-[#8994A3]"}`}>
          <UserCheck className="h-3 w-3" /> {lead.assigned_user_name ? `Bellen: ${lead.assigned_user_name}` : "Niet toegewezen"}
        </p>
      )}
      <p data-testid={`contacted-${lead.id}`} className={lead.last_contact_name ? "text-[#0C6E6E]" : "text-[#8994A3]"}>{contacted}</p>
    </div>
  );
}
